import { createAsyncThunk } from "@reduxjs/toolkit";
import { getApi, postApi } from "../../../services/apiServices";
import { DEALER_CODES, DELAER_DETAILS } from "../../constants/apiConstants";
import Alertify from "../../../services/alertify";

/*----------------Dealer Codes ---------------- */
export const DealerCodes = createAsyncThunk(
  "dealer-codes/admin",
  async (reqData) => {
    try {
      const response = await getApi(DEALER_CODES, reqData);
      return response;
    } catch (error) {
      console.log("Error Dealer Codes API", error);
      Alertify.error(error.message);
      return Promise.reject(error);
    }
  }
);
/*----------------Dealer Details ---------------- */
export const DealerDetails = createAsyncThunk(
  "dealer-details/admin",
  async (reqData) => {
    try {
      const response = await postApi(DELAER_DETAILS, reqData);
      return response;
    } catch (error) {
      console.log("Error Dealer Details API:", error);
      Alertify.error(error.message);
      return Promise.reject(error);
    }
  }
);
